import React from 'react';
import PropTypes from 'prop-types';
import { Card } from '@thd-olt-component-react/card';
import { EtchWidgets } from '@thd-olt-component-react/etch-widgets';
import { useProduct } from '@thd-nucleus/data-sources';

export const KeyFeatures = ({ itemId }) => {
  const { data, loading, error } = useProduct({ itemId, domains: ['media'] });

  if (!data || loading || error) {
    return null;
  }

  const {
    richContent
  } = data?.product?.media || {};

  if (!richContent) {
    return null;
  }

  const etchContent = (
    <EtchWidgets content={richContent?.content} />
  );
  return (
    <Card>
      <Card.Content title="Key Features" className="key-features-content">
        {etchContent}
        <Card.Content.Overlay>
          {etchContent}
        </Card.Content.Overlay>
      </Card.Content>
    </Card>
  );
};

KeyFeatures.displayName = 'KeyFeatures';

KeyFeatures.propTypes = {
  itemId: PropTypes.string.isRequired
};
